import { keyframes } from '@emotion/react';

export const spinAnimationKeyframes = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;
